export default {
  Inches: 'inches',
  Centimeters: 'centimeters',
}
